import styled from 'styled-components';
import { darkgrey } from 'styles/Colors';

export const OptionText = styled.div`
  color: ${darkgrey};
  font-size: 11px;
  margin-bottom: 6px;
`;
